
  const typeAuthorization = [
    { name: "API Enedis", id: "enedis", dso: 'ENEDIS', energy: 'electricity' },
    { name: "API GRDF", id: "grdf", dso: 'GRDF', energy: 'gas' },
    { name: "API Engie Bill-e (électricité)", id: "engiebilleelectricity", dso: 'ENGIE', energy: 'electricity' },
    { name: "API Engie Bill-e (gaz)", id: "engiebillegas", dso: 'ENGIE', energy: 'gas' },
    { name: "FTP Gaz De Bordeaux (gaz)", id: "gdbftpgas", dso: 'Gaz De Bordeaux', energy: 'gas' },
    { name: "FTP Regaz (gaz)", id: "regazftpgas", dso: 'Regaz', energy: 'gas' },
    { name: "SFTP Reseda", id: "resedasftp", dso: 'RESEDA', energy: 'electricity' },
    { name: "FTP SICAE Oise", id: "sicaeoiseftp", dso: 'SICAE Oise', energy: 'electricity' },
    { name: "SFTP Dalkia RCU", id: "dalkiarcusftp", dso: 'Dalkia RCU', energy: 'heat' },
    { name: "SFTP Strasbourg Electricite Reseaux", id: "sersftp", dso: 'Strasbourg Electricite Reseaux', energy: 'electricity' },
    { name: "API CPCU", id: "cpcu", dso: 'CPCU', energy: 'heat' },
    { name: "Email SICAE", id: "sicae", dso: 'SICAE', energy: 'electricity' },
    { name: "API Chorus", id: "chorus", dso: '', energy: '' },
    { name: "API DCX", id: "dcx", dso: '', energy: 'multiple' },
    { name: "API Dalkia", id: "dalkiaapi", dso: 'Dalkia RCU', energy: 'heat' },
  ];

  const statusEnergy = [
    { name: "Electricité", id: "electricity" },
    { name: "Gaz", id: "gas" },
    { name: "Eau", id: "water" },
    { name: "Réseau de chaleur", id: "heat" },
    { name: "Réseau frigorifique", id: "cold" },
    { name: "Fioul", id: "fuel" },
    { name: "Bois", id: "wood" },
    { name: "Gaz propane", id: "propane" },
    { name: "Multi énergies", id: "multiple" },
  ];

  const authorizationStatus = [
    { name: "En cours", id: 0, color: '#3E8FC6' },
    { name: "Validée", id: 1, color: '#91C73C' },
    { name: "Refusée", id: -1, color: '#C53F3F' },
  ];

  const typebyenergy = {
    electricity : [
      'enedis',
      'sicae',
      'sicaeoiseftp',
      'resedasftp',
      'sersftp',
    ],
    gas : [
      'grdf'
    ],
    heat : [
      'cpcu',
      'dalkiarcusftp',
      'dalkiaapi',
    ],
    multiple: [
      'dcx'
    ]
  }

  const utilitytypebyenergy = {
    electricity : [
      'engiebilleelectricity',
      'dcx',
    ],
    gas : [
      'engiebillegas',
      'gdbftpgas',
      'dcx',
    ],
    water : [
      'dcx',
    ],
    fuel : [
      'dcx',
    ],
    cold : [
      'dcx',
    ],
    heat : [
      'dcx',
      'dalkiaapi',
    ],
    wood : [
      'dcx',
    ],
    propane : [
      'dcx',
    ],
  }

export {  statusEnergy, typeAuthorization, authorizationStatus, typebyenergy, utilitytypebyenergy};
